import {subsetByURI, subsetByLangOrEmpty} from '../virtuoso/helper';
import {namespaces} from './settings';
/** Провайдер получения данных.  */
export class DataProviderBase {
  constructor(graph = null){
    this._graph = graph;
  }

  /** Возвращает типы, элементов (значения rdf:type)*/
  supportTypes(operation="view"){
    return [];
  }
  /** Выделяет подмножество значений, для элементов имеющих совпадение в значении предиката */
  subsetValuesByURI(values, uri, field="predicat"){
    return subsetByURI(values, uri, field);
  }

  /** Выделяет подмножество значений, для элементов имеющих совпадение в значении языка или пусто */
  subsetByLangOrEmpty(values, lang, fieldVar="predicat", langVar="object"){
    return subsetByLangOrEmpty(values, lang, fieldVar, langVar);
  }

  /** Получить значение метки для IRI, полученного из triplet */
  getLabelByIRI(IRI, lang=undefined, triplet=undefined){
    return Promise.resolve({IRI, label: IRI, lang: lang});
  }

  /**
   * Получает список доступных ствойств
   * rdfType - IRI типа элемента, для которого необходимо получить список свойств
   * purpose - назначение списка, например для добавления свойства, перевода и т.п.
   * значение 
   */
  getProperties(rdfType, purpose=undefined) {
    return [];
  }

  /** Сформировать короткое URI. skipNoExist если true, то возвращает укороченный URI с сгенерированным ns*/
  makeShortIRI(IRI, skipNoExist=false){
    const xmlns = vset.xmlns.filter(item => IRI.indexOf(item.uri)==0)
    const isExist = Array.isArray(xmlns) && xmlns.length>0;
    if (!isExist && !skipNoExist) return undefined;
    const lastIndexOf = (isExist)? xmlns[0].uri.length: Math.max(IRI.lastIndexOf("#"), IRI.lastIndexOf("/"))+1;
    const rPrefix = (prefix)?prefix: IRI.substring(0, lastIndexOf);
    const ns = (nameSpace)? nameSpace: (isExist)? xmlns[0].ns: "ns"+new Date().toISOString().slice(17, 23);
    const code = IRI.substring(lastIndexOf);
    return ns+":"+code;
  }
}